<template>
  <div>
    <div v-if="details && details.gstock_id"  >
      <div 
        :class="['close-btn-container', {'mobile': $md.mobile() && !$md.tablet()}]"      
        v-if="hiddenCloseButton" 
        @click="$emit('close')"
      >
        <img 
          class="close-button" 
          src="/ics/property/img/templates/logo_svg/close_white.svg"
        >
      </div>
      <div
        class="suggested-stock-container" 
        :data-action="eventAction" 
        :data-label="eventLabel" 
        @click="onCardClick">
        <div class="suggested-stock" v-if="$md.phone()">
          <div class="suggested-stock-photo">
            <stock-thumbnail :stock="details" :stock-tag-display="false" />
          </div>
          <div class="suggested-stock-info" :class="[{'no-right-border' : hiddenRightBorder}]">
            <div class="stock-info-header">
              <media-icon :stock="details" />
            </div>
            <div class="ics-tag-container">
              <ics-tag :ics-type="details.ics_type" />
            </div>
            <div class="stock-info-name">
              {{ $i18n.locale === 'en' ? details.eng_name : details.chi_name }}
            </div>
            <stock-card-area :stock="details" />
            <div class="text-right-bottom">
              <stock-card-price :stock="details" />
              <ref-info :stock="details" />
            </div>
          </div>
        </div>
      
        <div class="suggested-stock-desktop" v-else>
          <div class="suggested-stock-photo" :class="[`is-${details.ics_type}`]">
            <stock-thumbnail :stock="details" :is-desktop-view="true" :stock-tag-display="false"/>
          </div>
          <div class="suggested-stock-info">
            <div class="stock-info-header">
              <div class="header-info-group">
                <media-icon class="stock-media" :stock="details" />
                <div class="stock-district">
                  {{ $i18n.locale === 'en' ? details.dist_eng_name : details.dist_chi_name }}
                </div>
              </div>
              <ics-tag :ics-type="details.building_type" />
            </div>
            <div class="stock-info-name">
              {{ $i18n.locale === 'en' ? details.eng_name : details.chi_name }}
            </div>          
            <stock-card-area :stock="details" />
            <stock-card-description class="stock-description" :stock="details" :chi-limit="20" :eng-limit="40" />
            <div class="price-adjust">
              <stock-card-price :stock="details" />
            </div>
            <div class="contact-bar-adjust">
              <suggested-stock-contact :stock="details" />
            </div>          
          </div>
        </div>
      
        <div class="may-like-container">
          <may-like-tag />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stockApi from '@/api/stock';
import IcsTag from '@/components/Stock/IcsTag';
import StockThumbnail from '@/components/Stock/StockThumbnail';
import MediaIcon from '@/components/Stock/MediaIcon';
import StockCardArea from '@/components/Stock/StockCardArea';
import StockCardDescription from '@/components/Stock/StockCardDescription';
import StockCardPrice from '@/components/Stock/StockCardPrice';
import RefInfo from '@/components/Stock/RefInfo';
import SuggestedStockContact from '@/components/Stock/SuggestedStockContact';
import MayLikeTag from '@/components/Stock/MayLikeTag';

export default {
  components: {
    IcsTag,
    StockThumbnail,
    MediaIcon,
    StockCardArea,
    StockCardDescription,
    StockCardPrice,
    RefInfo,
    SuggestedStockContact,
    MayLikeTag,
  },
  props: {
    hiddenRightBorder: {
      type: Boolean,
      default: false,
    },
    hiddenCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      details: null,
      url: '#',
    };
  },
  mounted() {
    stockApi.getSuggestedStock()
    .then((suggestedStock) => {
      this.details = suggestedStock.details;
      this.url = suggestedStock.link;
    });
  },
  computed: {
    eventAction() {
      let gaAction = 'ICS';
      switch (this.details.ics_type) {
        case 'i':
          gaAction = 'Industrial';
          break;
        case 'c':
          gaAction = 'Commercial';
          break;
        case 's':
          gaAction = 'Shops';
          break;
        default:
          break;
      }
      return gaAction;
    },
    eventLabel() {
      let gaLabel = 'details-ics';
      switch (this.details.ics_type) {
        case 'i':
          gaLabel = 'details-i';
          break;
        case 'c':
          gaLabel = 'details-c';
          break;
        case 's':
          gaLabel = 'details-s';
          break;
        default:
          break;
      }
      gaLabel = `${gaLabel}-${this.details.gstock_id}`;
      return gaLabel;
    },
  },
  methods: {
    sendGA4Event() {
      if (this.details) {
        const gtmEvent = {
          'event': 'gotoSuggestedStock',
          'district': this.details.dist_chi_name,
          'company': this.details.company,
          'ics': this.details.ics_type,
          'stockType': this.details.stock_type,
          'txType': this.details.tx_type,
          'area': parseInt(this.details.area) + parseInt(this.details.attic_area),
          'price': this.details.price,
          'rent': this.details.rent,
          'ft_sell': this.details.ft_sell,
          'ft_rent': this.details.ft_rent,
          'negoprice': this.details.negoprice,
          'negorent': this.details.negorent
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(gtmEvent);
      }
    },
    onCardClick() {
      this.sendGA4Event();
      window.open(this.url, '_self');
    },
  },
};
</script>

<style scoped>
.suggested-stock-container {
  padding: 10px 0 0 0;
  position: relative;
  max-width: 768px;
  cursor: pointer;
  margin: 0 auto;
}

.suggested-stock, .suggested-stock-desktop, .header-info-group {
  display: flex;
}

.suggested-stock-photo {
  flex: 0 0 28%;
}

.suggested-stock-desktop > .suggested-stock-photo {
  flex: 0 0 15%;
}

.suggested-stock-desktop > .suggested-stock-photo.is-s {
  flex: 0 0 26%;
}

.suggested-stock-info {
  flex: 1;
  padding: 5px;
  border-width: 2px 2px 2px 0;
  border-style: solid;
  border-color: #eee;
  background: #fff;
  position: relative;  
}
.suggested-stock-info.no-right-border {
  border-right-width: 0;
}

.stock-info-header {
  display: flex;
  justify-content: space-between;
}
.stock-info-name {
  font-size: 20px;
}

.stock-media {
  margin-right: 5px;
}

.stock-district {
  color: #aaa;
}

.suggested-stock-desktop > .suggested-stock-info {
  position: relative;  
}

@media (max-width: 991px) {
  .suggested-stock-desktop .price-info-container {
    flex-flow: row;
  }  
}

.stock-description {
  position: absolute;
  bottom: 70px;
  right: 5px;
}

.price-adjust {
  position: absolute;
  bottom: 40px;
  right: 5px;
}

.contact-bar-adjust {
  margin: 0 -7px -2px -5px;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.may-like-container {
  position: absolute;
  top: 0;
  left: 0;
}

.text-right-bottom {
  position: absolute;
  bottom: 15px;
  right: 5px;
  text-align: right;
}

.ics-tag {
  position: absolute;
  top: 5px;
  right: 5px;
}

.close-btn-container.mobile {
  background: #DDDDDD;
  width: 30px;
  height: 30px;
  position: fixed;
  bottom: 158px;
  right: 0;
  z-index: 1000;
}

.close-button {
  margin: -5px;
}
</style>